import { render, staticRenderFns } from "./arContentDialog.vue?vue&type=template&id=07970b4a"
import script from "./arContentDialog.vue?vue&type=script&lang=js"
export * from "./arContentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports